import './navbar.css';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

const NavbarComponent = () => {
  return (
    <motion.nav
      className="navbar"
      initial={{ y: -100, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.6, ease: 'easeOut' }}
    >
      <div className="logo">TECH TROVE</div>

      <div className="navbar-right">
        <ul className="nav-links">
          <li><Link to="/">HOME</Link></li>
          <li><Link to="/about">ABOUT</Link></li>
          <li><Link to="/shop">SHOP</Link></li>
          <li><Link to="/contact">CONTACT</Link></li>
        </ul>

        <div className="icons">
          <span className="cart-icon">🛍️<span className="cart-count">0</span></span>
        </div>
      </div>
    </motion.nav>
  );
};

export default NavbarComponent;



